<app-blocks-workflow [blocks]="blocks" [models]="models" [context]="context"
                     (workflowComplete)="finishAction($event)"></app-blocks-workflow>
